// IBAN validation - 2 letters + 2 numbers + 11-30 alphanumeric characters
export const validateIBAN = (iban: string): boolean => {
  // Remove spaces for validation
  const cleanIban = iban.replace(/\s/g, '');

  // Check pattern: 2 letters + 2 numbers + 11-30 alphanumeric
  const ibanPattern = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/;

  return ibanPattern.test(cleanIban);
};

// Format IBAN with spaces for display (every 4 characters)
export const formatIBAN = (iban: string): string => {
  // Remove all spaces and convert to uppercase
  const cleanIban = iban.replace(/\s/g, '').toUpperCase();

  // Add space every 4 characters
  return cleanIban.match(/.{1,4}/g)?.join(' ') || cleanIban;
};

// Remove IBAN formatting for API submission
export const cleanIBAN = (iban: string): string => {
  return iban.replace(/\s/g, '').toUpperCase();
};

// Validate amount
export const validateAmount = (amount: number): boolean => {
  return amount > 0 && !isNaN(amount);
};

// Validate owner name
export const validateOwnerName = (name: string): boolean => {
  const trimmedName = name.trim();
  return trimmedName.length >= 1 && trimmedName.length <= 100;
};

// Validate reference
export const validateReference = (reference: string): boolean => {
  const trimmedRef = reference.trim();
  return trimmedRef.length >= 1 && trimmedRef.length <= 140;
};
